<div class="card">
    <div class="cardTitle">
        <h2>{{ 'dashboard.scheduledReports.title' | translate }}</h2>
    </div>

    <div class="cardContent">
        <form [formGroup]="form">
            <div class="inputGroup">
                <label for="scheduledReport">{{ 'dashboard.scheduledReports.scheduledReportType' | translate }}</label>
                <div class="inputWrapper">
                    <app-form-error
                        [parentForm]="$any(form)"
                        [controlPath]="'scheduledReportType'"
                        [controlLabel]="'dashboard.scheduledReports.scheduledReportType'"
                    />
                    <app-typeahead-select
                        type="text"
                        formControlName="scheduledReportType"
                        [id]="'scheduledReport'"
                        [optionsList]="scheduledReportTypes"
                        [idKey]="'value'"
                        [labelKey]="'label'"
                    />
                </div>
            </div>

            <div class="inputGroup">
                <label for="frequency">{{ 'dashboard.scheduledReports.frequency.label' | translate }}</label>
                <select type="text" id="frequency" formControlName="frequency" (change)="onFrequencyChange()">
                    <option [value]="ScheduledReportFrequency.DAILY">
                        {{ scheduledReportFrequencyTranslationMap[ScheduledReportFrequency.DAILY] | translate }}
                    </option>
                    <option [value]="ScheduledReportFrequency.WEEKLY">
                        {{ scheduledReportFrequencyTranslationMap[ScheduledReportFrequency.WEEKLY] | translate }}
                    </option>
                    <option [value]="ScheduledReportFrequency.MONTHLY">
                        {{ scheduledReportFrequencyTranslationMap[ScheduledReportFrequency.MONTHLY] | translate }}
                    </option>
                    <option [value]="ScheduledReportFrequency.MANUAL">
                        {{ scheduledReportFrequencyTranslationMap[ScheduledReportFrequency.MANUAL] | translate }}
                    </option>
                </select>
            </div>

            <div class="inputGroup" formGroupName="days" *ifNotDisabled="'days'">
                <div class="label">{{ 'dashboard.scheduledReports.days.label' | translate }}</div>

                <div class="inputWrapper">
                    <app-form-error
                        [parentForm]="$any(form)"
                        [controlPath]="'days'"
                        [controlLabel]="'dashboard.scheduledReports.days.label'"
                    />
                    <div class="days">
                        <span>
                            <input type="checkbox" id="monday" formControlName="monday" />
                            <label class="noLabelStyles" for="monday">{{ 'dashboard.scheduledReports.days.mon' | translate }}</label>
                        </span>

                        <span>
                            <input type="checkbox" id="tuesday" formControlName="tuesday" />
                            <label class="noLabelStyles" for="tuesday">{{ 'dashboard.scheduledReports.days.tue' | translate }}</label>
                        </span>

                        <span>
                            <input type="checkbox" id="wednesday" formControlName="wednesday" />
                            <label class="noLabelStyles" for="wednesday">{{ 'dashboard.scheduledReports.days.wed' | translate }}</label>
                        </span>

                        <span>
                            <input type="checkbox" id="thursday" formControlName="thursday" />
                            <label class="noLabelStyles" for="thursday">{{ 'dashboard.scheduledReports.days.thu' | translate }}</label>
                        </span>

                        <span>
                            <input type="checkbox" id="friday" formControlName="friday" />
                            <label class="noLabelStyles" for="friday">{{ 'dashboard.scheduledReports.days.fri' | translate }}</label>
                        </span>

                        <span>
                            <input type="checkbox" id="saturday" formControlName="saturday" />
                            <label class="noLabelStyles" for="saturday">{{ 'dashboard.scheduledReports.days.sat' | translate }}</label>
                        </span>

                        <span>
                            <input type="checkbox" id="sunday" formControlName="sunday" />
                            <label class="noLabelStyles" for="sunday">{{ 'dashboard.scheduledReports.days.sun' | translate }}</label>
                        </span>
                    </div>
                </div>
            </div>

            <div class="inputGroup" *ifNotDisabled="'dayOfMonth'">
                <label for="dayOfMonth">{{ 'dashboard.scheduledReports.dayOfMonth' | translate }}</label>
                <div class="inputWrapper">
                    <app-form-error
                        [parentForm]="$any(form)"
                        [controlPath]="'dayOfMonth'"
                        [controlLabel]="'dashboard.scheduledReports.dayOfMonth'"
                    />
                    <input type="number" id="dayOfMonth" formControlName="dayOfMonth" />
                </div>
            </div>

            <div class="inputGroup" *ifNotDisabled="'time'">
                <label for="time">{{ 'dashboard.scheduledReports.time.label' | translate }}</label>
                <div class="inputWrapper">
                    <app-form-error
                        [parentForm]="$any(form)"
                        [controlPath]="'time'"
                        [controlLabel]="'dashboard.scheduledReports.time.label'"
                    />
                    <input type="time" id="time" formControlName="time" />
                    <label for="time" class="suffix">{{ 'dashboard.scheduledReports.time.UTCTime' | translate }}</label>
                </div>
            </div>

            <div class="inputGroup">
                <label for="emails">{{ 'dashboard.scheduledReports.deliverToEmailAddresses' | translate }}</label>
                <div class="inputWrapper">
                    <app-form-error
                        [parentForm]="$any(form)"
                        [controlPath]="'emails'"
                        [controlLabel]="'dashboard.scheduledReports.deliverToEmailAddresses'"
                        [errorMessageOverrides]="{
                            emailListPattern: { errorKey: 'dashboard.scheduledReports.errors.invalidEmail' },
                        }"
                    />
                    <app-multi-input-control formControlName="emails" [labelKey]="'label'" [idKey]="'label'" [optionsList]="emails" />
                </div>
                <button type="button" class="button primary transparent link emailSettings" (click)="openEmailSettingsModal()">
                    {{ 'dashboard.scheduledReports.emailSettings.label' | translate }}
                </button>
            </div>

            <div class="inputGroup">
                <label for="deliverTo">{{ 'dashboard.scheduledReports.deliverToSFTPSites.label' | translate }}</label>
                <div class="inputWrapper">
                    <app-form-error
                        [parentForm]="$any(form)"
                        [controlPath]="'selectedSftpSettingsIds'"
                        [controlLabel]="'dashboard.scheduledReports.deliverToSFTPSites.label'"
                    />
                    <app-scheduled-reports-sftp-control formControlName="selectedSftpSettingsIds" [sftpData]="sftpData" />
                </div>
            </div>
        </form>
    </div>

    <div class="cardFooter">
        <button type="submit" class="button primary" (click)="saveScheduledReport()">
            {{ 'generalKeywords.confirm' | translate }}
        </button>
        <button type="button" class="button" (click)="closeModal()">
            {{ 'generalKeywords.cancel' | translate }}
        </button>
    </div>
</div>
